import {LocaleCode, generatePath} from '@legit-health/ui';
import {CONFIRMING_USER} from '@/shared/const/backend';
import useApiQuery from '@/shared/hooks/useApiQuery';
import useQueryParams from '@/shared/hooks/useQueryParams';

export type UserFromConfirmationTokenResponse = {
  name: string;
  surname: string;
  fullname: string;
  locale: LocaleCode;
  type: string;
  email: string | null;
  image: string | null;
  imageThumbnail: string | null;
  isAdmin: boolean;
  company: {
    name?: string | null;
    termsAndConditions?: string | null;
  };
};

export default function useUserFromConfirmationToken() {
  const queryParams = useQueryParams();
  const token = queryParams.get('token');
  const path = generatePath(CONFIRMING_USER, {
    confirmationToken: token ?? 'notused'
  });

  const query = useApiQuery<UserFromConfirmationTokenResponse>({
    queryOptions: {
      queryKey: [path],
      enabled: token !== null,
      retry: false,
      retryOnMount: false,
      staleTime: Infinity
    },
    requestArguments: {
      method: 'GET',
      path
    }
  });

  if (token === null) {
    return null;
  }

  return query;
}
